import styled from 'styled-components';
import { Modal } from '@mui/material';

import colors from '../../../../../styles/colors';

import Accordion from '../../../../../components/Accordion';
import { BaseTag } from '../../../../../components/Tags';

const Container = styled.div`
  overflow: auto;
  padding: 20px;
`;

const RecipeRow = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 10px;
  width: 100%;
  column-gap: 10px;
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.shades.secondary7};
  }
`;

const RecipeImage = styled.img`
  width: 48px;
  height: 40px;
  object-fit: cover;
  border-radius: 3px;
`;

const RecipeName = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.shades.secondary8};
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 8px;
`;

const ButtonContainer = styled.div`
  margin-left: auto;
`;

const StyledAccordion = styled(Accordion)`
  background-color: ${colors.base.alpha};
`;

const ReasonTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const StyledTag = styled(BaseTag)`
  background-color: ${colors.shades.secondary9};
  color: ${colors.shades.secondary8};
`;

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContentWrapper = styled.div`
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export {
  Container,
  RecipeRow,
  RecipeImage,
  RecipeName,
  ButtonContainer,
  StyledAccordion,
  ReasonTagsContainer,
  StyledTag,
  StyledModal,
  ModalContentWrapper,
};
